import type { TenantConfig, TenantCustomizations } from "src/tenantCustomizations/TenantCustomizations.ts";
import { otherControlChartSumOverWorkPeriodSamplingMethod } from "src/components/views/spc/commonSamplingMethods/otherControlChartSumOverWorkPeriodSamplingMethod.tsx";
import { otherControlChartsSumOverSamplingPeriodSamplingMethod } from "src/components/views/spc/commonSamplingMethods/otherControlChartsSumOverSamplingPeriodSamplingMethod.tsx";

export const DEFAULT_TENANT_CONFIG: TenantConfig = {
	erp: {
		enabled: false,
		salesEnabled: true,
		crmEnabled: false,
		accountingIntegrationEnabled: false,
		useCustomerOrderTenantStates: false,
		customerOrderTenantStates: [],
		customerOrderTenantStateColumnLabel: "",
		customerOrderFreezingEnabled: false,
		customerOrderCheckingEnabled: false,
		customerOrderCommentingEnabled: true,
		customerOfferContractPrintoutEnabled: false,
		customerOfferContractSigningEnabled: false,
		projectEnabled: true,
		reclamationsEnabled: false,
		configuratorEnabled: false,
		inputPricesWithVatByDefault: false,
		billingPlanEnabledByDefault: false,
		defaultCustomerType: "COMPANY",
		projectActivitySchedulingEnabled: false,
		surveysEnabled: false,
		purchaseEnabled: true,
		manufacturingEnabled: true,
		warehouseInventoryEnabled: true,
		reclamationRoundPlanningAiEnabled: false,
		customerOfferFormFieldsToHide: [],
		customerFormFieldsToHide: [],
		customerFormUseDefaultContact: false,
		winnerIntegrationEnabled: false,
		transportPlanningEnabled: false,
		deliveryPackageBundlingEnabled: false,
		projectActivityMaterialImportMethods: [],
		customerOfferLineImportMethods: ["STANDARD_TABULAR"],
		customerOrderLineImportMethods: ["STANDARD_TABULAR"],
		vectorEmbeddingsEnabled: false,
		jobQueueQrCodeEnabled: false,
		jobQueuePickingListEnabled: false,
		shopOrderTaskStatusInProductionPlanningEnabled: false,
		shopOrderPartListPrintedEnabled: false,
		partCostOverridesEnabled: false,
		documentCustomerSharingEnabled: false,
	},
	spc: {
		enabled: true,
		processImprovementsEnabled: false,
	},
	tasks: {
		enabled: false,
	},
	documentsEnabled: false,
	workspacesEnabled: false,
} as const;

export const DEFAULT_TENANT_CUSTOMIZATIONS: TenantCustomizations = {
	tenantConfig: DEFAULT_TENANT_CONFIG,
	spcSamplingMethods: () => [],
	erp: {
		sales: {
			customerOrderDataGridCustomColumns: () => [],
		},
	},
} as const;

export const defaultSpcSamplingMethods = [
	otherControlChartSumOverWorkPeriodSamplingMethod(),
	otherControlChartsSumOverSamplingPeriodSamplingMethod(),
];
